import { SearchApiBackend } from './backends/search-api';
export var searchApiFactory = function searchApiFactory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var backend = new SearchApiBackend(options);
  return {
    fetchListings: backend.fetchListings
  };
};